import { use, useEffect, useState } from "react";

import { useDataStore } from "@store/user_org";
import { useConfigStore } from "@store/persist";
import { isOwnerOrAdmin } from "@utils/permissions";
import { navigateTo } from "context/navigation.service";

import SettingBar from "@navigation/SettingBar";
import { Account } from "./settings/Account";
import { Company } from "./settings/Company";
import { Team } from "./settings/Team";
import { EmailTemplates } from "./settings/EmailTemplates";
import { Library } from "./settings/Library";
import { ProjectTemplates } from "./settings/ProjectTemplates";
import { PlanningTemplates } from "./settings/PlanningTemplates";
import { SyncOperations } from "./settings/SyncOperations";
import { EmailDesigns } from "./settings/EmailDesigns";
import EmailsSentScreen from "./EmailsSentScreen";
import { Disponibilites } from "./settings/disponibilites/Disponibilites";
import { ServiceRapide } from "./settings/service-rapide/ServiceRapide";
import { DispoAtelier } from "./settings/dispo-atelier/DispoAtelier";
import { MessagerieSettings } from "./settings/MessagerieSettings";
import { PriseDeRDV } from "./settings/PriseDeRDV";
import { Interventions } from "./settings/Interventions";
import { Tags } from "./settings/Tags";
import { Avis } from "./settings/Avis";
import { Payments } from "./settings/Payments";
import { Signatures } from "./settings/Signatures";
import { Users } from "./settings/Users";
import { NotificationsSettings } from "./settings/NotificationsSettings";
import { ServiceBoxSettings } from "./settings/ServiceBoxSettings";
import { ThreeCXSettings } from "./settings/ThreeCXSettings";
import { Storage } from "./settings/Storage";
import { DevisReminders } from "./settings/DevisReminders";
import { AppointmentReminders } from "./settings/AppointmentReminders";
import { ProxyDashboard } from "./settings/ProxyDashboard";
import { ServiceBoxTimings } from "./settings/ServiceBoxTimings";
import { AlphaRobot } from "./settings/AlphaRobot";
import { Communications } from "./settings/Communications";
import { ReceptionSettings } from "./settings/ReceptionSettings";
import { ServiceBoxSync } from "./settings/ServiceBoxSync";
import { ServiceBoxBatchTransfer } from "./settings/ServiceBoxBatchTransfer";
import { ClientVehiclesReview } from "./settings/ClientVehiclesReview";
import { Suivi } from "./settings/Suivi";
import { useParams, useSearchParams } from "react-router-dom";

const MANAGER_ONLY_PAGES = new Set([
  "dispo-atelier",
  "disponibilites",
  "service-rapide",
  "receptions",
  "prise-rdv",
  "interventions",
  "signatures",
  "devis-reminders",
  "rdv-reminders",
  "servicebox-batch-transfer",
  "client-vehicles",
  "suivi",
]);

export default function SettingsScreen() {
  const [searchParams] = useSearchParams();
  const orgData = useDataStore((state) => state.orgData);
  const userData = useDataStore((state) => state.userData);
  const prefix = useConfigStore((state) => state.prefix);
  const isAdmin = userData?.config?.admin === true;
  const isManager = isOwnerOrAdmin(userData);

  const [page, setPage] = useState<string>(
    searchParams.get("page") || "account",
  );

  useEffect(() => {
    setPage(searchParams.get("page") || "account");
  }, [searchParams]);

  useEffect(() => {
    if (!userData) return;
    if (MANAGER_ONLY_PAGES.has(page) && !isManager) {
      navigateTo({ route: "/home" });
    }
  }, [page, isManager, userData]);

  return (
    <div className="flex flex-row w-full max-w-full h-screen overflow-hidden">
      <SettingBar page={page} setPage={setPage}></SettingBar>
      <div className="flex flex-col w-full min-w-0 h-full overflow-y-auto">
        <div className="flex flex-col h-full">
          {page === "account" && <Account></Account>}
          {page === "dispo-atelier" && isManager && <DispoAtelier />}
          {(page === "disponibilites" || page === "service-rapide") && isManager && <DispoAtelier />}{" "}
          {page === "company" && <Company></Company>}{" "}
          {page === "team" && <Team></Team>}{" "}
          {page === "email-templates" && <EmailTemplates></EmailTemplates>}
          {page === "library" && <Library />}
          {page === "project-templates" && <ProjectTemplates />}
          {page === "planning-templates" && <PlanningTemplates />}
          {page === "sync-operations" && <SyncOperations />}
          {page === "email-designs" && <EmailDesigns />}
          {page === "emails-sent" && <EmailsSentScreen />}
          {(page === "whatsapp" || page === "messagerie" || page === "facturation") && <MessagerieSettings />}
          {page === "prise-rdv" && isManager && <PriseDeRDV />}
          {page === "receptions" && isManager && <ReceptionSettings />}
          {page === "interventions" && isManager && <Interventions />}
          {page === "tags" && <Tags />}
          {page === "avis" && <Avis />}
          {page === "signatures" && isManager && <Signatures />}
          {page === "paiements" && <Payments />}
          {page === "notifications" && <NotificationsSettings />}
          {page === "servicebox" && <ServiceBoxSettings />}
          {page === "servicebox-sync" && <ServiceBoxSync />}
          {page === "threecx" && <ThreeCXSettings />}
          {page === "stockage" && <Storage />}
          {page === "devis-reminders" && isManager && <DevisReminders />}
          {page === "rdv-reminders" && isManager && <AppointmentReminders />}
          {page === "users" && isAdmin && <Users />}
          {page === "proxy-dashboard" && isAdmin && <ProxyDashboard />}
          {page === "sb-timings" && isAdmin && <ServiceBoxTimings />}
          {page === "alpha-robot" && isAdmin && <AlphaRobot />}
          {page === "communications" && isAdmin && <Communications />}
          {page === "servicebox-batch-transfer" && isManager && <ServiceBoxBatchTransfer />}
          {page === "client-vehicles" && isManager && <ClientVehiclesReview />}
          {page === "suivi" && isManager && <Suivi />}
        </div>
      </div>
    </div>
  );
}
